import React, { Fragment } from "react";
import "./DashBoardGraph.css";
import Sidebar from "../../common/Sidebar/Sidebar";
import { FrameData1, FrameData2 } from "./data";
const DashBoardGraph = () => {
  return (
    <Fragment>
      <section className="AdminFrame">
        <div className="container-fluid">
          <div className="row">
            <Sidebar />
            <div className="col-11 mx-lg-0 mx-auto max-width pt-4 marginTop10">
              <div className="row">
                {/* Frame Data 1 */}
                {FrameData1.map((item) => {
                  const FrameImg = require(`../../assets/${item.GraphImg}`);
                  return (
                    <div className="col-lg-4 col-md-5 col-sm-6 offset-md-1 mt-sm-5 mt-3">
                      <div className="FrameImg">
                        <img src={FrameImg} alt="" />
                        <div className="Frame_Content">
                          <span>{item.Creator}</span>
                          <span>{item.Eth}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {/* Frame Data 2 */}
                {FrameData2.map((item) => {
                  const FrameImg2 = require(`../../assets/${item.GraphImg}`);
                  return (
                    <div className="col-lg-4 col-md-5 col-sm-6 offset-md-1 mt-sm-5 mt-3">
                      <div className="FrameImg">
                        <img src={FrameImg2} alt="" />
                        <div className="Frame2_Content">
                          <span>{item.AmountStash}</span>
                          <span>{item.Eth}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default DashBoardGraph;
